import dayjs from 'dayjs';

export const ALL_TIME_START_DATE = '01-01-1970';

export const getTodayDate = () => dayjs().format('DD-MM-YYYY');

export const getLast7DaysDateRange = () => ({
  start_date: dayjs().subtract(6, 'day').format('DD-MM-YYYY'),
  end_date: getTodayDate(),
});

export const isAllTimeDateRange = (startDate?: string, _endDate?: string) => startDate === ALL_TIME_START_DATE;

export const getDefaultConversationFilters = (conversationType = 'all') => ({
  ...getLast7DaysDateRange(),
  models: ['all'],
  categories: ['all'],
  rating: 'all',
  nps_rating: 'all',
  csat_rating: 'all',
  conversation_type: conversationType,
  has_knowledge_gap: 'all',
  inbox_filter_status: 'all',
  inbox_filter_reason: 'all',
  bookmark: 'all',
  sentiment: 'all',
  actions: 'all',
  rows_per_page: 30,
  page: 0,
});

export const parseConversationFilters = (search: string): Record<string, any> => {
  const filtersParam = new URLSearchParams(search).get('filters');
  if (!filtersParam) return {};

  try {
    const parsed = JSON.parse(filtersParam);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    try {
      const parsed = JSON.parse(decodeURIComponent(filtersParam));
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }
};

export const getConversationPath = (conversationId: string, conversationType = 'all') => {
  const path = `/conversations/${encodeURIComponent(conversationId)}`;
  if (!conversationType || conversationType === 'all') return path;

  return `${path}?filters=${encodeURIComponent(JSON.stringify({ conversation_type: conversationType }))}`;
};
